export enum AlertCreationSections {
    ALERT_CREATION_SECTION_ONPAGE_SEARCH_CTA_POP_UP_STEP_2 = 2,
    ALERT_CREATION_SECTION_ONPAGE_SEARCH_BOTTOM = 3,
    ALERT_CREATION_SECTION_ONPAGE_SEARCH_BOTTOM_STEP_2 = 29,
    ALERT_CREATION_SECTION_ONPAGE_SEARCH_CTA_POP_UP = 61,
    ALERT_CREATION_SECTION_PAID_REGULARLANDING_POPUP = 63,
    ALERT_CREATION_SECTION_ADPAGE_BOX = 100,
    ALERT_CREATION_SECTION_ADPAGE_FORM_CHECKBOX = 102,
    ALERT_CREATION_SECTION_ADPAGE_FREE_CLICKOUT = 103,
    ALERT_CREATION_SECTION_GOOGLEONE_TAP_GOOGLE_POPUP = 199
}